import { fetchFactory, urlUtils } from 'isotope-client'

export const getModelesTacheTypes = (famille) => fetchFactory(`/taches/modelesTache/types/${famille}`)

export const getModelesTaches = (famille, type, values) => fetchFactory(`/taches/modeleTache/${famille}/${type}`, {
	method: 'POST',
	body: JSON.stringify(values)
})

export const getAllModeleTache = (idFerme, isGenerique = null, itkId = null, etape = null, typeEntity = null, moTacheId = null) => fetchFactory(urlUtils.buildUrlWithParams(`/bo/modeleTache/filter`, { idFerme, isGenerique, itkId, etape, typeEntity, moTacheId }))

export const getAllPlanchesWithoutId = () => fetchFactory('/planche')

export const createTache = (semaine, values) => fetchFactory(`/taches/createTaches/${semaine}`, {
	method: 'POST',
	body: JSON.stringify(values)
})

export const updateTache = (id, values) => fetchFactory(`/taches/updateTache/${id}`, {
	method: 'POST',
	body: JSON.stringify(values)
})

export const validerPlanification = (semaine) => fetchFactory('/taches/valider-semaine', {
	method: 'post',
	body: JSON.stringify({ semaine })
})

export const getSyntheseDatas = (isDebug) => fetchFactory(urlUtils.buildUrlWithParams('/taches/synthese', {isDebug}))

export const getSyntheseDetailDatas = (tachesPlanifiees) => fetchFactory(urlUtils.buildUrlWithParams('/taches/synthese/detail', { tachesPlanifiees }))